import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatDialogCloseEvent } from '../../../const';
import { ClientAccountDetails } from '../../../models/mat-account.model';
import { MatAccountService } from '../../mat-account/mat-account.service';
import { ToastrService } from 'ngx-toastr';
import { HttpErrorResponse } from '@angular/common/http';
import { SharedService } from '../../../shared/services/shared.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-swap-package',
    templateUrl: './swap-package.component.html'
})
export class SwapPackageComponent implements OnInit {
  userDetails:any;
  selectedPackage: number = 0;
  activeTab: string = "Package";
  notes: string = "";
  isEdit: boolean = false;

  constructor(@Inject(MAT_DIALOG_DATA) public data: ClientAccountDetails,
  @Optional() private dialogRef: MatDialogRef<SwapPackageComponent>, private matAccountService: MatAccountService,
  private toasterService: ToastrService, private sharedService: SharedService, private router: Router
  ) {}

  ngOnInit(): void {
    this.selectedPackage = this.data.packageId;
    this.notes = this.data.comment!;
    this.sharedService.isEdit$.subscribe(isEdit => {
      this.isEdit = isEdit;
    });
  }

  swapPackage(){
    this.data.comment = this.notes;
    this.data.newPackageId = !this.data.newPackageId ? this.data.packageId : this.data.newPackageId;
    this.matAccountService.swapPackage(this.data).subscribe((response: boolean | any)=>{
      if(response){
        this.toasterService.success("Package swapped successfully", "Success");
        this.dialogRef.close({event:MatDialogCloseEvent.SUCCESS});
        
        //Send Notification
        this.sharedService.fetchNotification(true);
      }
    },(error: HttpErrorResponse)=>{
      if(error.error){
        this.toasterService.error(error.error, "Error");
      }
    })
  }

  receivedPackage(packageId: number) {
    this.selectedPackage = packageId;
    this.data.newPackageId = this.selectedPackage;
  }
  
  cancel(){
    this.dialogRef.close({event:MatDialogCloseEvent.CANCELLED});
  }
}
